import React, { useState, useEffect, useMemo, MouseEventHandler } from 'react'
import { useRequest } from 'ahooks'
import { getBalance } from '../shared-api/api'
import { CText } from '../shared_components/CText'
import { colors } from '../shared-constants/colors'
import { fontSize, fontsWeight } from '../shared-constants/fonts'
import { dimens } from '../shared-constants/dimens'
import styled from 'styled-components'
import useUpgradeLevelModal from './useUpgradeLevelModal'
import { isUserNeedUpgrade } from '../shared-constants/userLevel'
import CustomLoading from '../shared_components/CustomLoading'
import {
  getAccessToken,
  getRefreshToken,
} from '../shared-constants/localstorage'
import { CAMPAIGN_ID } from '../shared-constants/campaignId'
import { icons } from '../shared-asstes/icons'
import { useNavigate } from 'react-router-dom'
import { pathes } from '@/routing/pathes'

function useBalance() {
  const [balance, setBalance] = useState<number>()
  const [balanceData, setBalanceData] = useState()
  const { openUpgradeUserModal } = useUpgradeLevelModal()
  const navigate = useNavigate()
  const balanceString = useMemo(
    () => (balance || +balance === 0 ? balance?.toLocaleString() + '' : ''),
    [balance],
  )
  const onReload: MouseEventHandler<HTMLImageElement> = (e) => {
    e.preventDefault()
    fetchBalance()
  }
  const { run: fetchBalance, loading: loadingBalance } = useRequest(
    getBalance,
    {
      manual: true,
      debounceWait: 1000,
      debounceLeading: true,
      cacheKey: 'balance',
      onSuccess(data: any) {
        setBalance(
          data?.balanceList?.find(
            (item) => item?.campaignID === CAMPAIGN_ID.SHAHRVANDI,
          )?.balance,
        )
        setBalanceData(data)
      },
      // onError(error: any) {

      // },
    },
  )
  const BalanceCText = () => {
    if (isUserNeedUpgrade()) {
      return upgradeLevel()
    } else {
      return (
        <>
          {loadingBalance ? (
            <CustomLoading size='small' cMargin='0' />
          ) : (
            <BalanceContainer>
              <Balance>{balanceString}&nbsp;</Balance>
              <span>ریال</span>
              {!balance && (
                <img
                  src={icons.RELOAD_BLACK}
                  id='reload-balance'
                  onClick={onReload}
                />
              )}
            </BalanceContainer>
          )}
        </>
      )
    }
  }

  const upgradeLevel = () => {
    return (
      <UnderLineText onClick={openUpgradeUserModal} color={colors.PRIMARY}>
        {'فعال سازی کیف پول'}
      </UnderLineText>
    )
  }

  useEffect(() => {
    if (isUserNeedUpgrade()) {
    } else if (getRefreshToken()) {
      fetchBalance()
    }
  }, [])

  return {
    balance,
    loadingBalance,
    balanceString,
    BalanceCText,
    balanceData,
    fetchBalance,
  }
}

const Balance = styled.span`
  font-size: ${fontSize.EXTRA_LARGE};
  font-weight: ${fontsWeight.BOLD};
`

const UnderLineText = styled(CText)`
  text-decoration: underline;
  font-weight: 500;
`

const BalanceContainer = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: ${dimens.SPACING_S};
    cursor: pointer;
  }
`

export default useBalance
